export default __webpack_public_path__ + "static/media/profileSendMessageIcon.dfee9768.svg";